import { SpaceSummaryRail } from "@/react/components/Spaces/AiSummary/SpaceSummaryRail";
import type { SpaceDateRange } from "@/react/types/AiSummary/SpaceSummary";
import type { Space } from "@/react/types/Space";

interface PostSpaceSummaryProps {
  dateRange: SpaceDateRange;
  isOpen: boolean;
  onClose: () => void;
  space: Space;
}

export const PostSpaceSummary = ({
  isOpen,
  onClose,
  space,
  dateRange,
}: PostSpaceSummaryProps) => (
  <SpaceSummaryRail
    isOpen={isOpen}
    onClose={onClose}
    space={space}
    dateRange={dateRange}
    type="post"
  />
);
